import { render, staticRenderFns } from "./study-report.vue?vue&type=template&id=32e185dc&scoped=true&"
import script from "./study-report.vue?vue&type=script&lang=js&"
export * from "./study-report.vue?vue&type=script&lang=js&"
import style0 from "./study-report.vue?vue&type=style&index=0&id=32e185dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e185dc",
  null
  
)

export default component.exports